<template>
  <div v-if="showPricingTierProgress">
    <transition
      enter-active-class="transition-all ease-in duration-200"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition-all ease-out duration-200"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
      appear
    >
      <PricingTierProgressBarSimple v-if="hasPricingTierWarning" :compact="compact" />
      <PricingTierProgressBar v-else :compact="compact" />
    </transition>
  </div>
</template>

<script>
import { isUpgradedTier } from '@/utils/pricingTierDiscount'
import PricingTierProgressBar from '@/components/PricingTierProgressBar.vue'
import PricingTierProgressBarSimple from '@/components/PricingTierProgressBarSimple.vue'

export default {
  components: { PricingTierProgressBar, PricingTierProgressBarSimple },
  props: {
    overrideShow: {
      type: Boolean,
      required: false,
      default: false
    },
    persist: {
      type: Boolean,
      required: false,
      default: false
    },
    compact: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      timeout: null,
      showBar: false
    }
  },
  computed: {
    cart() {
      return this.$store.getters.currentCart
    },
    bottle() {
      return this.$store.getters.currentBottle
    },
    store() {
      return this.$store.getters.store(this.bottle?.relationships?.store?.data)
    },
    hasPricingTierWarning() {
      return !!this.store?.attributes?.pricing_tier_warning
    },
    showPricingTierProgress() {
      return this.persist || this.overrideShow || this.showBar
    },
    pricingTierID() {
      return this.cart?.relationships?.pricing_tier?.data?.id
    },
    nextPricingTierID() {
      return this.cart?.relationships?.next_pricing_tier?.data?.id
    },
    nextPricingTier() {
      return this.$store.getters.pricingTierWithID(this.nextPricingTierID)
    },
    progressPercentage() {
      return this.cart?.attributes?.progress_toward_next_pricing_tier
    }
  },
  watch: {
    pricingTierID: function (newPricingTierID, oldPricingTierID) {
      const newPricingTier = this.$store.getters.pricingTierWithID(newPricingTierID)
      const oldPricingTier = this.$store.getters.pricingTierWithID(oldPricingTierID)
      if (oldPricingTier && newPricingTier && isUpgradedTier(newPricingTier, oldPricingTier)) {
        this.flashPricingTier()
      }
    },
    progressPercentage: function () {
      this.flashPricingTier()
    }
  },
  methods: {
    flashPricingTier() {
      if (this.timeout) {
        clearTimeout(this.timeout)
        this.timeout = null
      }
      this.showBar = true
      if (!this.persist) {
        this.timeout = setTimeout(() => {
          this.showBar = false
        }, 6000)
      }
    }
  }
}
</script>
